import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
export default function MaterialPrompt(props) {
  const [saved, setSaved] = React.useState(false)
  const theme = useTheme();
  const [value, setValue] = React.useState(props.defaultValue ? props.defaultValue : "")

  const handleSave = () => {
    props.done(value);
  }

  return (
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={props.close}
        open={props.open}
        sx={{ padding: '50px', zIndex: theme?.custom?.dialogZIndex }}
        >
        <Box
          sx={{
            alignItems: 'center',
            backgroundColor: '#1c445b',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 8px 8px 16px',
          }}
          >
          <Typography variant="h6">
            {props?.prompt} 
          </Typography>
          <IconButton
            color="inherit"
            onClick={props.close}
            >
            <HighlightOffSharpIcon fontSize="medium" />
          </IconButton>
        </Box>
        <DialogContent sx={{ ...props?.styles, paddingBottom: '60px' }}>
          
            <TextField value={value} onChange={(e) => {
                setValue(e.target.value);
            }} fullWidth label="" id="prompt-text-box" />
          <Button disabled={saved} 
          sx={{ 
            position: 'absolute', 
            bottom: 7, 
            right: 7, 
            bgcolor: '#2372AD',
            '&:hover': {
              backgroundColor: '#3683b0',
            }, 
          }} 
          onClick={handleSave} 
          variant="contained">
            Save
          </Button>

        </DialogContent>
      </Dialog>
  );
};
